// Signing in with a passkey, for our team. There are no passwords.

import { useState } from 'react';
import { api, message } from '../api.ts';
import { passkeyProblem, passkeysAvailable, usePasskey, type GetOptions } from '../passkey.ts';
import type { Person } from '../types.ts';
import { useMe, useRoute } from '../ui.tsx';

export function SignIn() {
  const { setPerson } = useMe();
  const { path, go } = useRoute();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const signIn = async () => {
    setBusy(true);
    setError(null);
    try {
      const options = await api<GetOptions>('POST', '/auth/options', {});
      let response;
      try {
        response = await usePasskey(options);
      } catch (e) {
        setError(passkeyProblem(e));
        return;
      }
      const { person } = await api<{ person: Person }>('POST', '/auth/sign-in', { response });
      setPerson(person);
      go(path === '/' || path === '/sign-in' ? '/sites' : path);
    } catch (e) {
      setError(message(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="center">
      <div className="solo">
        <div className="brand">
          <span className="brand-mark">Z.A.S.</span>
          <span className="faint">Console</span>
        </div>
        <h1>Sign in</h1>
        <p className="muted">Use your passkey: Face ID, fingerprint or your device PIN. There are no passwords.</p>
        {passkeysAvailable() ? (
          <button className="btn primary" onClick={signIn} disabled={busy}>
            {busy ? 'Waiting for your passkey…' : 'Sign in with a passkey'}
          </button>
        ) : (
          <p className="error">This browser can't use passkeys. Try an up-to-date Safari, Chrome or Edge.</p>
        )}
        {error && (
          <p className="error" role="alert">
            {error}
          </p>
        )}
      </div>
      <p className="faint small">{location.host} · Nothing here can send an alert or see where anyone is.</p>
    </div>
  );
}
